import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiSquare, FiShield, FiDollarSign, FiCoffee, FiKey, FiInfo } = FiIcons;

const OnboardingTaskRow = ({ item, onToggle }) => {
  const getCategoryIcon = (cat) => {
    switch (cat) {
      case 'Compliance': return FiShield;
      case 'Financial': return FiDollarSign;
      case 'Hospitality': return FiCoffee;
      case 'Access': return FiKey;
      default: return FiInfo;
    }
  };

  const getCategoryStyles = (cat) => {
    switch (cat) {
      case 'Compliance': return 'bg-blue-50 text-blue-600';
      case 'Financial': return 'bg-green-50 text-green-600';
      case 'Hospitality': return 'bg-purple-50 text-purple-600';
      case 'Access': return 'bg-amber-50 text-amber-600';
      default: return 'bg-gray-50 text-gray-600';
    }
  };

  return (
    <div 
      onClick={() => onToggle(item.id)}
      className={`p-4 rounded-2xl border transition-all cursor-pointer flex items-center justify-between group ${item.completed ? 'bg-gray-50/50 border-gray-100 opacity-60' : 'bg-white border-gray-200 hover:border-indigo-300 hover:shadow-md'}`}
    >
      <div className="flex items-center gap-4">
        <div className={`w-6 h-6 rounded-lg flex items-center justify-center transition-colors ${item.completed ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-300 group-hover:bg-indigo-100 group-hover:text-indigo-600'}`}>
          <SafeIcon icon={item.completed ? FiCheck : FiSquare} size={14} />
        </div>
        <div>
          <p className={`text-sm font-black ${item.completed ? 'text-gray-400 line-through' : 'text-gray-900'}`}>{item.task}</p>
          <div className="flex items-center gap-2 mt-1">
            <span className={`px-1.5 py-0.5 rounded text-[8px] font-black uppercase tracking-widest flex items-center gap-1 ${getCategoryStyles(item.category)}`}>
              <SafeIcon icon={getCategoryIcon(item.category)} size={8} />
              {item.category}
            </span>
            {item.date && <span className="text-[8px] font-bold text-gray-400 uppercase tracking-tighter">Completed {item.date}</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingTaskRow;